var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.002,
    height: 20.934,
    viewBox: "0 0 17.002 20.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_406",
    "data-name": "Caminho 406",
    d: "M222.888,154.7a.49.49,0,0,0-.49.49v9.266a.49.49,0,1,0,.98,0v-9.266A.49.49,0,0,0,222.888,154.7Zm0,0",
    transform: "translate(-211.495 -147.119)",
    fill: "#009ebe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_407",
    "data-name": "Caminho 407",
    d: "M104.888,154.7a.49.49,0,0,0-.49.49v9.266a.49.49,0,1,0,.98,0v-9.266A.49.49,0,0,0,104.888,154.7Zm0,0",
    transform: "translate(-99.28 -147.119)",
    fill: "#009ebe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_408",
    "data-name": "Caminho 408",
    d: "M1.389,6.231V18.309a2.7,2.7,0,0,0,.719,1.865,2.414,2.414,0,0,0,1.752.757h9.276a2.414,2.414,0,0,0,1.752-.757,2.7,2.7,0,0,0,.719-1.865V6.231a1.873,1.873,0,0,0-.48-3.683h-2.51V1.935A1.926,1.926,0,0,0,10.674,0H6.321A1.926,1.926,0,0,0,4.38,1.935v.613H1.87a1.873,1.873,0,0,0-.48,3.683ZM13.135,19.952H3.86a1.553,1.553,0,0,1-1.49-1.642V6.274H14.626V18.309a1.553,1.553,0,0,1-1.49,1.642ZM5.36,1.935A.944.944,0,0,1,6.321.979h4.353a.944.944,0,0,1,.961.956v.613H5.36ZM1.87,3.528H15.126a.882.882,0,0,1,0,1.765H1.87a.882.882,0,0,1,0-1.765Zm0,0",
    transform: "translate(0.003 0.002)",
    fill: "#009ebe"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_409",
    "data-name": "Caminho 409",
    d: "M163.888,154.7a.49.49,0,0,0-.49.49v9.266a.49.49,0,1,0,.98,0v-9.266A.49.49,0,0,0,163.888,154.7Zm0,0",
    transform: "translate(-155.387 -147.119)",
    fill: "#009ebe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9f5d01b5014c692c551d908b7be03347.svg";
export { ForwardRef as ReactComponent };